import { isAxiosError } from 'axios';
import { extractBackendErrorDetail } from '~/features/utils';

// Match validate_publishable's messages; the server remains authoritative.
const PUBLISH_GUIDANCE: Record<string, string> = {
  'specialties is required to activate.': 'Select Edit to add at least one specialty.',
  'licenseStates is required to activate.': 'Select Edit to add at least one license state.',
  'geographies is required to activate.':
    'Select Edit to add a location for onsite or hybrid work.',
  'providerCategoryId is required to activate.':
    'Complete your provider category in your profile, then select Edit and save the listing.',
  'listingTitle is required to activate.': 'Select Edit to add a listing title.',
  'listingKind is required to activate.': 'Select Edit to choose a work mode.',
  'workLocation is required to activate.': 'Select Edit to choose a work location.',
  'timezone is required to activate.': 'Select Edit and save the listing to set its timezone.',
  'workPreference is required to activate.':
    'Select Edit to complete Work Preferences and save the listing.',
  'Future Calendar availability is required to activate.':
    'Open Calendar to add future available dates for this listing or your general availability.',
  'A current or future Calendar recurring rule is required to activate.':
    'Open Calendar to add a current or future recurring availability rule for this listing or your general availability.',
};

export const publicationErrorMessage = (error: unknown): string => {
  const detail = isAxiosError(error) ? error.response?.data?.detail : undefined;
  const errors =
    detail && typeof detail === 'object' && Array.isArray(detail.errors)
      ? detail.errors.filter((item: unknown): item is string => typeof item === 'string')
      : [];
  const backendDetail = extractBackendErrorDetail(detail);
  const messages: string[] = errors.length ? errors : backendDetail ? [backendDetail] : [];
  const guidance = messages.map((message) => PUBLISH_GUIDANCE[message] ?? message).join(' ');
  return `Unable to publish this listing.${guidance ? ` ${guidance}` : ''} ${
    messages.some((message) => PUBLISH_GUIDANCE[message])
      ? 'After making changes, try Publish again.'
      : 'Please try Publish again. If the problem continues, contact support.'
  }`;
};
